import * as React from "react";
import { useHistory, useParams } from "react-router";

import {
  constants as apartmentCommoditiesConstants,
  updateDefaultSettings as apartmentUpdateDefaultSettings,
  createManyUrl as apartmentCreateManyUrl,
} from "../../../../store/marketApartmentCommodities";
import {
  constants as indpCommoditiesConstants,
  updateDefaultSettings as indpUpdateDefaultSettings,
  createManyUrl as indpCreateManyUrl,
} from "../../../../store/marketIndustrialPremisesCommodities";

import FlowFormBase from "../../Base/FlowForm/FlowFormBase";
import chapterDefs from "./chapterDefs";
import descriptions from "./Descriptions";
import chapters from "./Chapters";
import FullPageSpinner from "../../../Loaders/FullPageSpinner";
import useQuery from "../../../utils/useQuery";
import { AD_CREATE_TYPES } from "../../../../views/Market/ManyHandling/ManyCommoditiesRootObjectSelect";

const getConstants = (type) => {
  if (type === AD_CREATE_TYPES.INDP) return indpCommoditiesConstants;
  if (type === AD_CREATE_TYPES.APARTMENT) return apartmentCommoditiesConstants;
};
const getUpdateDefaultSettings = (type) => {
  if (type === AD_CREATE_TYPES.INDP) return indpUpdateDefaultSettings;
  if (type === AD_CREATE_TYPES.APARTMENT) return apartmentUpdateDefaultSettings;
};
const getCreateManyUrl = (type) => {
  if (type === AD_CREATE_TYPES.INDP) return indpCreateManyUrl;
  if (type === AD_CREATE_TYPES.APARTMENT) return apartmentCreateManyUrl;
};

export default function ManyCommoditiesFlowForm() {
  const { type } = useParams();
  const constants = getConstants(type);

  const updateDefaultSettings = getUpdateDefaultSettings(type);
  const createManyUrl = getCreateManyUrl(type);
  const storeName = constants.STORE_NAME;
  const [loading, setLoading] = React.useState(false);
  const { push } = useHistory();
  const query = useQuery();
  const buildingId = query.get("building");

  const onSubmit = () => {
    push(`${createManyUrl({ type })}?building=${buildingId}`);
  };

  return (
    <>
      {loading && <FullPageSpinner />}

      <FlowFormBase
        {...{
          storeName,
          chapterDefs: chapterDefs(),
          chapters,
          descriptions,
          onSubmit,
          type,
          constants,
          updateDefaultSettings,
          title: "Grundinställningar för annonsdetaljer",
        }}
      />
    </>
  );
}
